export default {
  allChanges: 'all',
  content: 'content',
  comments: 'comments',
};
